<template>
  <div class="right">
    <div class="rightTop">
      <div class="right-top">
        <div class="modle-title">
          <i class="iconfont">&#xe7f7;</i>
          <span>SaaS系统赋能态势</span>
        </div>
        <div style="display: flex;justify-content: space-around;">
          <div
            class="feedback-box-item"
            v-for="(item, index) in offline.saasData"
            :key="index"
          >
            <Feed :chart-id="'feed' + index" :chart-data="item"></Feed>
            <span class="dis-text">{{ item.title }}</span>
          </div>
        </div>

        <div
          style="width:100%;height:10rem;display: flex;margin-top:20px;justify-content: space-around;"
        >
          <div id="fuwu" style="width:50%;height:13rem;"></div>
          <div id="zhiliang" style="width:50%;height:13rem;"></div>
        </div>
      </div>
    </div>

    <div class="center">
      <div class="modle-title">
        <i className="iconfont">&#xe7fd;</i>
        <span>SaaS系统使用对比雷达图</span>
      </div>
      <div id="leidacom" style="width:100%;height:15rem"></div>
    </div>

    <div class="rightbt">
      <dv-borderBox13 class="right-bottom-borderBox13">
        <div class="right-bottom">
          <div class="modle-title">
            <i class="iconfont">&#xe790;</i>
            <span>运营服务生态内容提供</span>
          </div>
          <dv-capsuleChart :config="config" class="capsule"></dv-capsuleChart>
          <!-- <div class="feedback-box">
            <div
              class="feedback-box-item"
              v-for="(item, index) in offline.feedback"
              :key="index"
            >
              <Feed :chart-id="'feed' + index" :chart-data="item"></Feed>
              <span class="dis-text">{{ item.title }}</span>
            </div>
          </div> -->
          <!-- <div class="offline-portal-box">
            <div id="offline" class="protal"></div>
          </div> -->
        </div>
      </dv-borderBox13>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts"
import Feed from "./feed.vue"
export default {
  components: {
    Feed,
  },

  data() {
    return {
      config: {
        // 单位
        unit: "（个/月）",
        showValue: false,
        data: [
          {
            name: "残友自生产内容",
            value: 100,
          },
          {
            name: "党建娱乐",
            value: 130,
          },
          {
            name: "生活便利",
            value: 100,
          },
          {
            name: "健康医疗",
            value: 160,
          },
          {
            name: "就业内容",
            value: 200,
          },
          {
            name: "培训内容",
            value: 230,
          },
        ],
      },
      browseCategories: {
        data: [782, 621.2, 322.1, 525.3, 265, 224],
        indicator: [
          {
            name: "食物",
            max: 1000,
          },
          {
            name: "娱乐",
            max: 1000,
          },
          {
            name: "运动",
            max: 1000,
          },
          {
            name: "家居",
            max: 1000,
          },
          {
            name: "机械",
            max: 1000,
          },
          {
            name: "学习",
            max: 1000,
          },
        ],
      },
      offline: {
        feedback: [
          {
            title: "性别占比（男性）",
            number: 68,
          },
          {
            title: "年龄占比（60岁以上）",
            number: 56,
          },
        ],
        saasData: [
          {
            title: "SaaS系统使用率",
            number: 87,
          },
          {
            title: "残疾人之家自营率",
            number: 10,
          },
          {
            title: "覆盖残疾人使用率",
            number: 68,
          },
        ],
        PortalData: {
          data1: [80, 152, 101, 134, 90, 130],
          data2: [120, 182, 191, 210, 170, 110],
          data3: [110, 132, 201, 154, 150, 80],
          data4: [90, 142, 161, 114, 190, 170],
          xData: ["9:00", "12:00", "15:00", "18:00", "21:00", "00:00"],
          barData: [32.2, 60.0, 32.6, 36.4, 53.3, 35.0],
        },
      },
    }
  },
  mounted() {
    // this.BrowseOptions()
    this.OfflineOptions()
    this.OfflineOptions2()
    this.leidaComOptions()
  },
  methods: {
    BrowseOptions() {
      var chartDom = document.getElementById("leida")
      var myChart = echarts.init(chartDom)

      var img =
        "data:image/png;base64,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"

      var trafficWay = [
        {
          name: "视力",
          value: 8.15,
        },
        {
          name: "听力",
          value: 11.59,
        },
        {
          name: "言语",
          value: 0.56,
        },
        {
          name: "肢体",
          value: 53.36,
        },
        {
          name: "智力",
          value: 9.93,
        },
        {
          name: "精神",
          value: 7,
        },
        {
          name: "多重",
          value: 9.35,
        },
      ]

      var data = []
      var color = [
        "#00ffff",
        "#00cfff",
        "#006ced",
        "#ffe000",
        "#ffa800",
        "#ff5b00",
        "#ff3000",
      ]
      for (var i = 0; i < trafficWay.length; i++) {
        data.push(
          {
            value: trafficWay[i].value,
            name: trafficWay[i].name,
            itemStyle: {
              normal: {
                borderWidth: 5,
                shadowBlur: 20,
                borderColor: color[i],
                shadowColor: color[i],
              },
            },
          },
          {
            value: 2,
            name: "",
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                color: "rgba(0, 0, 0, 0)",
                borderColor: "rgba(0, 0, 0, 0)",
                borderWidth: 0,
              },
            },
          }
        )
      }
      var seriesOption = [
        {
          name: "",
          type: "pie",
          clockWise: false,
          radius: [55, 59],
          hoverAnimation: false,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: "outside",
                color: "#ddd",
                formatter: function(params) {
                  var percent = 0
                  var total = 0
                  for (var i = 0; i < trafficWay.length; i++) {
                    total += trafficWay[i].value
                  }
                  percent = ((params.value / total) * 100).toFixed(2)
                  if (params.name !== "") {
                    return params.name + "\n" + "\n" + percent + "%"
                  } else {
                    return ""
                  }
                },
              },
              labelLine: {
                length: 20,
                length2: 10,
                show: true,
                color: "#00ffff",
              },
            },
          },
          data: data,
        },
      ]

      var option
      option = {
        color: color,
        title: {
          text: "残疾人分类",
          top: "45%",
          textAlign: "center",
          left: "49%",
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontWeight: "400",
          },
        },
        graphic: {
          elements: [
            {
              type: "image",
              z: 3,
              style: {
                image: img,
                width: 78,
                height: 78,
              },
              left: "center",
              top: "center",
              position: [100, 100],
            },
          ],
        },
        tooltip: {
          show: false,
        },
        legend: {
          icon: "circle",
          orient: "horizontal",
          data: ["视力", "听力", "言语", "肢体", "智力", "精神", "多重"],
          right: 340,
          bottom: 150,
          align: "right",
          textStyle: {
            color: "#fff",
          },
          itemGap: 20,
        },
        toolbox: {
          show: false,
        },
        series: seriesOption,

        // title: {
        //   show: false,
        // },
        // tooltip: {
        //   trigger: "item",
        // },
        // legend: {
        //   show: false,
        //   orient: "vertical",
        //   left: "left",
        // },
        // series: [
        //   {
        //     // name: "",
        //     type: "pie",
        //     radius: [30, 80],
        //     center: ["50%", "50%"],
        //     roseType: "area",
        //     itemStyle: {
        //       borderRadius: 5,
        //     },
        //     data: [
        //       { value: 2359, name: "视力" },
        //       { value: 3352, name: "听力" },
        //       { value: 164, name: "言语" },
        //       { value: 15431, name: "肢体" },
        //       { value: 2873, name: "智力" },
        //       { value: 2032, name: "精神" },
        //       { value: 2706, name: "多重" },
        //     ],
        //     // emphasis: {
        //     //   itemStyle: {
        //     //     shadowBlur: 10,
        //     //     shadowOffsetX: 0,
        //     //     shadowColor: "rgba(0, 0, 0, 0.5)",
        //     //   },
        //     // },
        //   },
        // ],
        // radar: {
        //   center: ["50%", "50%"],
        //   radius: "70%",
        //   name: {
        //     formatter: function(name) {
        //       let arr
        //       arr = ["{a|" + name + "}"]
        //       return arr.join("\n")
        //     },
        //     textStyle: {
        //       rich: {
        //         //根据文字的组设置格式
        //         a: {
        //           color: "#BCDCFF",
        //           fontSize: 14,
        //           fontWeight: 600,
        //           fontFamily: "Source Han Sans CN",
        //         },
        //       },
        //     },
        //   },
        //   // 名字和图形的距离
        //   nameGap: 5,
        //   indicator: this.browseCategories.indicator,
        //   splitLine: {
        //     show: false,
        //   },
        //   axisLine: {
        //     show: false,
        //   },
        //   splitArea: {
        //     areaStyle: {
        //       color: [
        //         "rgba(84,136,255, 0.05)",
        //         "rgba(84,136,255, 0.1)",
        //         "rgba(84,136,255, 0.2)",
        //         "rgba(84,136,255, 0.3)",
        //         "rgba(84,136,255, 0.4)",
        //         "rgba(84,136,255, 0.5)",
        //       ].reverse(),
        //       shadowColor: "rgba(0, 0, 0, .5)",
        //       shadowBlur: 5,
        //       shadowOffsetX: 10,
        //       shadowOffsetY: 10,
        //     },
        //   },
        // },
        // series: [
        //   {
        //     name: "用户浏览类别",
        //     type: "radar",
        //     data: [this.browseCategories.data],
        //     label: {
        //       show: false,
        //       formatter: function(params) {
        //         return params.value + "万"
        //       },
        //       color: "#9ae8ac",
        //       distance: 10,
        //       align: "right",
        //     },
        //     symbol: "none",
        //     symbolSize: [6, 6],
        //     // 边缘颜色
        //     lineStyle: {
        //       color: "rgba(160,159,246, 0.6)",
        //       width: 2,
        //     },
        //     areaStyle: {
        //       color: "rgba(114,113,233,.4)",
        //       opacity: 0.8,
        //       shadowColor: "rgba(115,149,255,1)",
        //       shadowBlur: 10,
        //     },
        //   },
        // ],
      }
      myChart.setOption(option)
      window.addEventListener("resize", function() {
        myChart.resize() //下面可以接多个图
      })
    },

    OfflineOptions() {
      var offlinechartDom = document.getElementById("fuwu")
      var offlineChart = echarts.init(offlinechartDom)

      var scaleData = [
        {
          name: "100以下人次",
          value: 30,
        },
        {
          name: "300人次",
          value: 150,
        },
        {
          name: "500人次",
          value: 500,
        },
        {
          name: "1000人次",
          value: 800,
        },
        {
          name: "1000以上人次",
          value: 400,
        },
      ]

      var rich = {
        white: {
          color: "#ddd",
          align: "center",
          padding: [5, 0],
        },
      }
      var placeHolderStyle = {
        normal: {
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          color: "rgba(0, 0, 0, 0)",
          borderColor: "rgba(0, 0, 0, 0)",
          borderWidth: 0,
        },
      }
      var data = []
      for (var i = 0; i < scaleData.length; i++) {
        data.push(
          {
            value: scaleData[i].value,
            name: scaleData[i].name,
            itemStyle: {
              normal: {
                borderWidth: 1,
                shadowBlur: 20,
                borderColor: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
                  {
                    offset: 0,
                    color: "#7777eb",
                  },
                  {
                    offset: 1,
                    color: "#70ffac",
                  },
                ]),
                shadowColor: "rgba(142, 152, 241, 0.6)",
              },
            },
          },
          {
            value: 4,
            name: "",
            itemStyle: placeHolderStyle,
          }
        )
      }
      var seriesObj = [
        {
          name: "",
          type: "pie",
          clockWise: false,
          radius: [30, 45],
          hoverAnimation: false,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: "outside",
                color: "#ddd",
                formatter: function(params) {
                  var percent = 0
                  var total = 0
                  for (var i = 0; i < scaleData.length; i++) {
                    total += scaleData[i].value
                  }
                  percent = ((params.value / total) * 100).toFixed(0)
                  if (params.name !== "") {
                    return params.name + "\n{white|" + percent + "%}"
                  } else {
                    return ""
                  }
                },
                rich: rich,
              },
              labelLine: {
                show: false,
                length: 10,
                length2: 3,
              },
            },
          },
          data: data,
        },
      ]
      var option = {
        title: {
          text: "残疾人之家服务人次分布",
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
          bottom: "5%",
          left: "16%",
        },
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },
        toolbox: {
          show: false,
        },
        series: seriesObj,
      }
      offlineChart.setOption(option)
      window.addEventListener("resize", function() {
        offlineChart.resize() //下面可以接多个图
      })
    },
    OfflineOptions2() {
      var offlinechartDom = document.getElementById("zhiliang")
      var offlineChart = echarts.init(offlinechartDom)

      var scaleData = [
        {
          name: "优秀",
          value: 210,
        },
        {
          name: "良好",
          value: 30,
        },
        {
          name: "合格",
          value: 45,
        },
        {
          name: "不合格",
          value: 23,
        },
      ]

      var rich = {
        white: {
          color: "#ddd",
          align: "center",
          padding: [5, 0],
        },
      }
      var placeHolderStyle = {
        normal: {
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          color: "rgba(0, 0, 0, 0)",
          borderColor: "rgba(0, 0, 0, 0)",
          borderWidth: 0,
        },
      }
      var data = []
      for (var i = 0; i < scaleData.length; i++) {
        data.push(
          {
            value: scaleData[i].value,
            name: scaleData[i].name,
            itemStyle: {
              normal: {
                borderWidth: 1,
                shadowBlur: 20,
                borderColor: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
                  {
                    offset: 0,
                    color: "#7777eb",
                  },
                  {
                    offset: 1,
                    color: "#70ffac",
                  },
                ]),
                shadowColor: "rgba(142, 152, 241, 0.6)",
              },
            },
          },
          {
            value: 4,
            name: "",
            itemStyle: placeHolderStyle,
          }
        )
      }
      var seriesObj = [
        {
          name: "",
          type: "pie",
          clockWise: false,
          radius: [30, 45],
          hoverAnimation: false,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: "outside",
                color: "#ddd",
                formatter: function(params) {
                  var percent = 0
                  var total = 0
                  for (var i = 0; i < scaleData.length; i++) {
                    total += scaleData[i].value
                  }
                  percent = ((params.value / total) * 100).toFixed(0)
                  if (params.name !== "") {
                    return params.name + "\n{white|" + percent + "%}"
                  } else {
                    return ""
                  }
                },
                rich: rich,
              },
              labelLine: {
                show: false,
                length: 10,
                length2: 3,
              },
            },
          },
          data: data,
        },
      ]
      var option = {
        title: {
          text: "残疾人之家服务质量分布",
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
          bottom: "5%",
          left: "16%",
        },
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },
        toolbox: {
          show: false,
        },
        series: seriesObj,
      }
      offlineChart.setOption(option)
      window.addEventListener("resize", function() {
        offlineChart.resize() //下面可以接多个图
      })
    },

    leidaComOptions() {
       var offlinechartDom = document.getElementById("leidacom")
      var offlineChart = echarts.init(offlinechartDom)

      var legendData = ["SaaS化管理", "未使用系统"] //图例

      var indicator = [
        {
          text: "规范化",
          max: 100,
        },
        {
          text: "服务效果",
          max: 100,
        },
        {
          text: "服务能力",
          max: 100,
        },
        {
          text: "运营人效",
          max: 100,
          //  axisLabel: {show: true, textStyle: {fontSize: 18, color: '#333'}}
        },
        {
          text: "流程化",
          max: 100,
        },
      ]
      var dataArr = [
        {
          value: [90, 90, 80, 70, 90],
          name: legendData[0],
          itemStyle: {
            normal: {
              lineStyle: {
                color: "#4A99FF",
                // shadowColor: '#4A99FF',
                // shadowBlur: 10,
              },
              shadowColor: "#4A99FF",
              shadowBlur: 10,
            },
          },
          areaStyle: {
            normal: {
              // 单项区域填充样式
              color: {
                type: "linear",
                x: 0, //右
                y: 0, //下
                x2: 1, //左
                y2: 1, //上
                colorStops: [
                  {
                    offset: 0,
                    color: "#4A99FF",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(0,0,0,0)",
                  },
                  {
                    offset: 1,
                    color: "#4A99FF",
                  },
                ],
                globalCoord: false,
              },
              opacity: 1, // 区域透明度
            },
          },
        },
        {
          value: [30, 25, 30, 30, 55],
          name: legendData[1],
          itemStyle: {
            normal: {
              lineStyle: {
                color: "#4BFFFC",
                // shadowColor: '#4BFFFC',
                // shadowBlur: 10,
              },
              shadowColor: "#4BFFFC",
              shadowBlur: 10,
            },
          },
          areaStyle: {
            normal: {
              // 单项区域填充样式
              color: {
                type: "linear",
                x: 0, //右
                y: 0, //下
                x2: 1, //左
                y2: 1, //上
                colorStops: [
                  {
                    offset: 0,
                    color: "#4BFFFC",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(0,0,0,0)",
                  },
                  {
                    offset: 1,
                    color: "#4BFFFC",
                  },
                ],
                globalCoord: false,
              },
              opacity: 1, // 区域透明度
            },
          },
        },
      ]
      var colorArr = ["#4A99FF", "#4BFFFC"] //颜色
      var option = {
        title: {
          show: false,
          textStyle: {
            color: "#fff",
            fontSize: "14",
          },
          subtextStyle: {
            color: "#90979c",
            fontSize: "14",
          },
        },
        color: colorArr,
        legend: {
          orient: "horizontal",
          icon: "circle", //图例形状
          data: legendData,
          bottom: 0,
          right: "30%",
          itemWidth: 14, // 图例标记的图形宽度。[ default: 25 ]
          itemHeight: 14, // 图例标记的图形高度。[ default: 14 ]
          itemGap: 21, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
          textStyle: {
            fontSize: 14,
            color: "#00E4FF",
          },
        },
        radar: {
          // shape: 'circle',
          name: {
            textStyle: {
              color: "#fff",
              fontSize: 16,
            },
          },
          indicator: indicator,
          splitArea: {
            // 坐标轴在 grid 区域中的分隔区域，默认不显示。
            show: true,
            areaStyle: {
              // 分隔区域的样式设置。
              color: ["rgba(255,255,255,0)", "rgba(255,255,255,0)"], // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
            },
          },
          axisLine: {
            //指向外圈文本的分隔线样式
            lineStyle: {
              color: "#153269",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#113865", // 分隔线颜色
              width: 1, // 分隔线线宽
            },
          },
        },
        series: [
          {
            type: "radar",
            symbolSize: 8,
            // symbol: 'angle',
            data: dataArr,
          },
        ],
      }
      offlineChart.setOption(option)
      window.addEventListener("resize", function() {
        offlineChart.resize() //下面可以接多个图
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.right {
  width: 35rem;
  height: auto;
}
.rightTop {
  position: relative;
  height: 25rem;
  width: 100%;
  margin-bottom: 1.25rem;
  .right-top {
    &-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.9375rem;
    }
    .earth-gif {
      width: 10rem;
      height: auto;
      border-radius: 50%;
      overflow: hidden;
    }
  }
}

.center {
  position: relative;
  height: 17.625rem;
  width: 100%;
  margin-bottom: 1.25rem;
}

.rightbt {
  position: relative;
  height: 18rem;
  width: 100%;
  .right-bottom-borderBox13 {
    padding: 1.25rem 0.9375rem 0.9375rem;
    .right-bottom {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      background-color: rgba(19, 25, 47, 0.6);
      .feedback-box {
        margin-top: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: space-around;
        &-item {
          display: flex;
          align-items: center;
          flex-direction: column;
          height: 8.75rem;
          .dis-text {
            font-weight: bold;
            margin-top: 0.3125rem;
            color: #b2cfee;
            font-size: 1rem;
            background: linear-gradient(to bottom, #fff, #6176f4);
            color: transparent;
            -webkit-background-clip: text;
            background-clip: text;
          }
        }
      }
      .offline-portal-box {
        margin-top: 0.625rem;
      }
    }
  }
}

.modle-title {
  padding: 0.625rem 0.625rem;
  color: #bcdcff;
  font-size: 1rem;
  font-weight: bold;
  .iconfont {
    font-size: 0.875rem;
    margin-right: 0.625rem;
    color: #89e5ff;
    font-weight: 400;
  }
}

.leida_chart {
  width: 19rem;
  height: 12.5rem;
}
.capsule {
  width: 29.25rem;
  height: 13.125rem;
}
.protal {
  width: 26.875rem;
  height: 14.375rem;
}
</style>
